import React from "react";
import { Globe, Search, Clock, CheckCircle } from "lucide-react";

export default function StatsByNumbers() {
  const stats = [
    {
      Icon: Globe,
      value: "10,000+",
      label: "Websites Discovered",
      accent: "from-blue-500 to-indigo-500",
    },
    {
      Icon: Search,
      value: "500+",
      label: "Searches Run Daily",
      accent: "from-green-500 to-emerald-400",
    },
    {
      Icon: Clock,
      value: "10+",
      label: "Hours Saved / Week (avg)",
      accent: "from-yellow-500 to-orange-400",
    },
    {
      Icon: CheckCircle,
      value: "15,000+",
      label: "Credits Delivered",
      accent: "from-purple-500 to-pink-500",
    },
  ];

  return (
    <section className="relative py-24 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
      {/* Static soft background blob (no animation) */}
      <div className="absolute -bottom-32 -right-32 w-[400px] h-[400px] bg-yellow-200/30 rounded-full blur-[120px] -z-10"></div>

      <div className="max-w-6xl mx-auto text-center px-4 sm:px-6">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-6">
          By the{" "}
          <span className="bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text text-transparent">
            Numbers
          </span>
        </h2>

        <p className="text-gray-600 text-lg max-w-2xl mx-auto mb-12">
          Every day, Backlink Banana helps link builders and SEO teams find better sites,
          faster, here’s what that looks like in action.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {stats.map(({ Icon, value, label, accent }, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl shadow-md p-8 border border-gray-100 
                         hover:shadow-lg hover:-translate-y-1 transform transition-all duration-300"
            >
              <Icon className="h-10 w-10 text-gray-700 mb-3 mx-auto" />
              <div
                className={`text-4xl font-extrabold bg-gradient-to-r ${accent} bg-clip-text text-transparent mb-2`}
              >
                {value}
              </div>
              <p className="text-gray-600 text-sm font-medium">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
